module.exports = __webpack_public_path__ + "static/img/10019.80b3b5ed.png";